import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { API_BASE_URL } from "../config";
import "../styles/components/ProductCard.scss";

function ProductCard({ product }) {
  const { addToCart, openCart } = useCart();
  const navigate = useNavigate();

  const hasDiscount =
    Number(product.discount_percentage) > 0 &&
    Number(product.final_price) > 0 &&
    Number(product.final_price) < Number(product.original_price);

  const imageUrl = product.image
    ? `${API_BASE_URL}/images/products/${product.image}`
    : `${API_BASE_URL}/images/products/default.jpg`;

  // A product with a real color choice (2+ available colors) can't be
  // quick-added here - this card has no picker UI and the listing API
  // deliberately doesn't send the full color list to keep cards light, so
  // there's nothing valid to attach. Send the customer to the product page
  // to actually choose instead of silently adding a colorless line (the
  // bug this replaced: it used to add straight to cart regardless).
  const onAdd = () => {
    if (product.requires_color_selection) {
      navigate(`/product/${product.id}`);
      return;
    }

    addToCart(product, 1);
    openCart();
  };

  return (
    <div
      className="product-card"
      onMouseMove={(e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        e.currentTarget.style.setProperty("--x", `${e.clientX - rect.left}px`);
        e.currentTarget.style.setProperty("--y", `${e.clientY - rect.top}px`);
      }}
    >
      <Link to={`/product/${product.id}`} className="product-media-link">
        <img src={imageUrl} alt={product.name} loading="lazy" decoding="async" />

        <div className="product-info">
          <h3 className="product-name">{product.name}</h3>

          <div className="price">
            {hasDiscount ? (
              <>
                <span className="price-new">
                  ${Number(product.final_price).toFixed(2)}
                </span>
                <span className="price-old">
                  ${Number(product.original_price).toFixed(2)}
                </span>
                <span className="discount-badge">
                  -{Number(product.discount_percentage).toFixed(0)}%
                </span>
              </>
            ) : (
              <span className="price-normal">
                ${Number(product.original_price).toFixed(2)}
              </span>
            )}
          </div>
        </div>
      </Link>

      <div className="product-actions">
        <button
          type="button"
          className="add-btn"
          onClick={onAdd}
          aria-label={
            product.requires_color_selection
              ? `Choose a color for ${product.name}`
              : `Add ${product.name} to cart`
          }
        >
          {product.requires_color_selection ? "Choose Color" : "Add"}
        </button>
      </div>
    </div>
  );
}

export default ProductCard;